export enum AuthorizedSignatory {
  Inspector = 'Inspector',
  Reviewer = 'Reviewer',
}
